import { render, staticRenderFns } from "./SlidePromoteListPopup.vue?vue&type=template&id=da2889e8&"
import script from "./SlidePromoteListPopup.vue?vue&type=script&lang=js&"
export * from "./SlidePromoteListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports